<template>
  <div>
    <SearchForm
      :searchForm="initParam"
      :searchFormTemp="searchFormTemp"
      :authBtn="'bbc:customer:page'"
      @normalSearch="normalSearch"
      @normalResetQuery="normalResetQuery"
      labelWidth="120px"
    >
      <el-button slot="exportBtn" type="primary" @click="retrieveExport" plain>导出</el-button>
    </SearchForm>
    <Table :data="listData" :options="listDataOptions" :align="'center'"></Table>
    <Pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :pageData="initParam"
      :total="total"
    ></Pagination>
  </div>
</template>
<script>
import SearchForm from '@/components/layouts/SearchForm';
import Pagination from '@/components/layouts/Pagination';
import Table from '@/components/layouts/table';
import { myMixin } from '@/mixins/index';
import { enterprisePointRetrievePage ,enterprisePointRetrieveExport} from '@/api/integralManage';
export default {
  mixins: [myMixin],
  components: {
    SearchForm,
    Pagination,
    Table,
  },

  data() {
    return {
      initParam: {
        pageNum: 1,
        pageSize: 10,
        param: {
          enterpriseId: '',
          recordId: '',
          startTime: '',
          endTime: '',
        },
      },
      total: 0,
      searchFormTemp: [
        { lable: '批次号', name: 'recordId', type: 'input' },
        { lable: '操作时间起期', name: 'startTime', type: 'datePicker' },
        { lable: '操作时间止期', name: 'endTime', type: 'datePicker' },
      ],
      listData: [],
      listDataOptions: [
        { prop: 'recordId', label: '批次号' ,width:200},
        { prop: 'retrievePhone', label: '手机号' },
        { prop: 'retrievePoints', label: '回收积分' },
        { prop: 'retrieveValidTime', label: '积分有效期' },
        { prop: 'retrieveCreateTime', label: '操作时间' },
        { prop: 'retrieveCreateId', label: '操作人', dic: 'allUserDics' },
      ],
    };
  },
  methods: {
    init() {
      this.queryData();
    },
    async queryData(bool = true) {
      // 默认将当前页数归1HR
      if (bool) this.initParam.pageNum = 1;
      this.initParam.param.enterpriseId = this.$store.state.user.user.enterpriseId;
      let res = await enterprisePointRetrievePage(this.initParam);
      this.listData = res.list;
      this.total = res.total;
    },
    clear() {
      this.initParam.param.recordId = '';
      this.initParam.param.startTime = '';
      this.initParam.param.endTime = '';
    },
    retrieveExport() {
      this.initParam.param.enterpriseId = this.$store.state.user.user.enterpriseId;
      enterprisePointRetrieveExport('回收明细.xlsx',this.initParam.param)
    },
  },
};
</script>
<style lang="less" scoped>
</style>